import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=db8246e0&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db8246e0')) {
      api.createRecord('db8246e0', component.options)
    } else {
      api.reload('db8246e0', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=db8246e0&", function () {
      api.rerender('db8246e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W11z5WKS4bCC/JS/offershelp.vue"
export default component.exports